
export async function convertPngToJpeg(file, quality = 0.9) {
  // Check if the file is a PNG
  if (file.type !== 'image/png') {
    // Return original file if it's not PNG
    return file;
  }

  return new Promise((resolve, reject) => {
    // Create a canvas element
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    
    // Create an image element
    const img = new Image();
    
    img.onload = function() {
      // Set canvas dimensions to match image
      canvas.width = img.width;
      canvas.height = img.height;
      
      // Draw the image on canvas
      ctx.drawImage(img, 0, 0);
      
      // Convert canvas to JPEG blob
      canvas.toBlob((blob) => {
        if (blob) {
          // Create a new File object with JPEG data
          const jpegFile = new File([blob], 
            file.name.replace(/\.png$/i, '.jpg'), 
            { type: 'image/jpeg', lastModified: Date.now() }
          );
          resolve(jpegFile);
        } else {
          reject(new Error('Failed to convert PNG to JPEG'));
        }
      }, 'image/jpeg', quality);
    };
    
    img.onerror = function() {
      reject(new Error('Failed to load image'));
    };
    
    // Load the PNG file
    img.src = URL.createObjectURL(file);
  });
}
